import { gql } from '@apollo/client';

const UPDATE_COMPANY_ADDRESS_SETTINGS_AND_VALUES = gql`
mutation updateCompanyAddressSettingsAndValues(
	$settings: CompanyAdddressSettingsInput!
	$address: UpdateCompanyAddressesInput!
) {
	companyAdminContext {
		companyAddressSettings {
			updateCompanyAddressesAndSettings(
				addresses: $address
				settings: $settings
			) {
				errorResult {
					data {
						key
						value
					}
					errorCode
					errorMessage
				}
				success
			}
		}
	}
}
`;

export default UPDATE_COMPANY_ADDRESS_SETTINGS_AND_VALUES;